module.exports = __webpack_public_path__ + "img/drivingLicense.bac95fc8.svg";